import { render, staticRenderFns } from "./PhoneButton.vue?vue&type=template&id=7eedc12e&"
import script from "./PhoneButton.vue?vue&type=script&lang=js&"
export * from "./PhoneButton.vue?vue&type=script&lang=js&"
import style0 from "./PhoneButton.vue?vue&type=style&index=0&id=7eedc12e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports